<template>
    <section>
        <div class="recruit_section2">
            <div class="con_wrap" style="padding-top: 270px; margin-bottom: 161px;">
                <div>
                    <p style="font-size: 35px; font-weight: 700; color: black; margin-bottom: 76px;">아낌없는 보상과 지원</p> 
                    <div style="display: flex; flex-wrap: wrap;">
                        <div v-for="(item, index) in benefit" :key="index" style="width: 33.33%; display: flex; flex-wrap: wrap; flex-direction: column; align-items: flex-start; margin-bottom: 70px;">
                            <img :src="require('@/assets/images/main_v2/icon/'+ item.icon +'.svg')" alt="" style="width: 30px; margin-bottom: 12px;">
                            <p data-aos="fade"
                                :data-aos-delay="0"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out"  style="font-size: 26px; font-weight: 700; line-height: 1.5; color: black">{{item.title}}</p>
                            <p data-aos="fade"
                                :data-aos-delay="0"
                                data-aos-once="true"
                                data-aos-duration="600"
                                data-aos-easing="ease-in-out"  style="font-size: 21px; font-weight: 400; line-height: 1.5;" v-html="changeRow(item.detail)"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar
    },
    data() {
        return {
            joinProcess: [
                {
                    'text': '서류전형',
                    'size': 483,
                    'color' : '#1C9CD3'
                },{
                    'text': '대면면접',
                    'size': 278,
                    'color' : '#1C9CD399'
                },{
                    'text': '결과',
                    'size': 123,
                    'color' : '#1C9CD333'
                },
            ],
            benefit: [
                {
                    'title': '탄력 근무제 시행',
                    'detail': '10 to 6 또는 11 to 7\n원하는 근무 시간에 출근해요',
                    'icon': 'work'
                },{
                    'title': '내일채움공제 가입',
                    'detail': '내일채움공제 조건 충족 시 가입 가능\n내일채움공제 가입을 적극 지원해요',
                    'icon': 'cash'
                },{
                    'title': '리프레쉬 휴일',
                    'detail': '매달 마지막 주 금요일 리프레쉬 휴일\n각자 힐링하는 시간을 가져봐요',
                    'icon': 'bed'
                },{
                    'title': '주 1회 재택근무',
                    'detail': '주 1회 재택근무 가능\n집에서 편하게 근무해요',
                    'icon': 'home'
                },{
                    'title': '생일자 혜택',
                    'detail': '생일을 맞아 치킨 기프티콘 제공\n생일자한테는 치킨을 쏩니다. 빵야',
                    'icon': 'celebrate'
                },{
                    'title': '기기 지원',
                    'detail': '노트북 Window, MAC 택 1 제공\n스마트한 시대에 스마트한 노트북 제공',
                    'icon': 'laptop'
                },{
                    'title': '중식 제공',
                    'detail': '맛있는 점심식사 제공\n우리밥은 먹고 합시다!',
                    'icon': 'lunch'
                },{
                    'title': '자기계발 지원',
                    'detail': '도서 및 자기계발 지원\n마음의 양식을 쌓고 성장해봐요',
                    'icon': 'book'
                },{
                    'title': '수평적인 호칭',
                    'detail': '모두 "님" 호칭, 직급호칭제 폐지\n우리의 호칭은 모두 "님"으로 통일해요',
                    'icon': 'name'
                },
            ],
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        changeRow(val) {
            return val.split('\n').join('<br />')
        },
        setIcon(val)  {
            return require('@/assets/images/main_v2/icon/'+ val.icon +'.svg')
        }
        // copy(val) {
        //     navigator.clipboard.writeText(val).then(()=> {
        //         this.$store.commit('SET_SNACK_BAR_INFO' , {
        //             text: '메일주소가 복사되었습니다.',
        //             icon: 'icon-check.svg',
        //             color: 'white',
        //             background: '#1C9CD3'
        //         })
        //         this.showSnackBar = true
        //     })
        // },
    }
    
}
</script>
<style>
    .recruit_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .box_join_process {
        padding: 38px 0; 
        border-radius: 100px;
        margin-right: 30px;
        font-weight: 700;
        font-size: 30px;
        color: black; 
        line-height: 1.5; 
        text-align: center;
    }
</style>